import * as React from 'react';
import { Form, Props } from '@websky/core/src/Checkout/components/Checkout/Form/Form';

const OverriddenCheckoutForm: React.FC<Props> = props => {
	return <Form {...props} showCheckDataModal={true} />;
};

export default OverriddenCheckoutForm;
